// This JavaScript file is created by Cision for our estimate module.
// This is the first version of this file so far.
// This should be combined with estimateannual.html

var cision = cision || {};
cision.websolution = cision.websolution || {};
cision.websolution.texts = cision.websolution.texts || {};
cision.websolution.estimate = cision.websolution.estimate || {};
cision.websolution.settings = cision.websolution.settings || {};
cision.websolution.formatHelpers = cision.websolution.formatHelpers || {};

cision.websolution.estimate.historical = !cision.websolution.settings.estimate ? {} : function ($) {
    var settings = $.extend({}, cision.websolution.settings.general),
        accessKey = cision.websolution.settings.estimate.accessKey,
        chart;

    function generateUrl(path) {
        var url = settings.useProxyHandler
            ? settings.proxyHandler + '?url=' + settings.serviceEndpoint + path
            : settings.serviceEndpoint + path;

        return url;
    }

    var render = function (options) {

            if (options) {
                $.extend(settings, options);
            }
            if (!accessKey) {
                console.log("You must provide your access key.");
                return;
            }
            var url = generateUrl('Estimate/' + accessKey + '/Historical');

            $.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                data: {
                    field: settings.field
                }
            })
                .done(function (objRawData) {
                    var seriesList = transformKeyFigures(objRawData);

                    createChart(seriesList);
                })
                .fail(function () {
                    console.log('Could not retrieve historical data');
                });
        };

    function transformKeyFigures(objData) {

        var keyFigures = objData.HistoricalKeyFigures,
            objSeriesList = {};

        $.each(keyFigures, function (ix, objKeyFigure) {
            var notToAdd = objKeyFigure.Field == "EBIT" && objKeyFigure.Unit == "Percent";
            if (!notToAdd) {
                var isEstimate = objKeyFigure.Type.toLowerCase() === 'estimate',
                    key = objKeyFigure.Period + '_y' + (isEstimate ? '' : '_actual');

                if (!objSeriesList.hasOwnProperty(key)) {
                    // Add the key
                    objSeriesList[key] = {
                        id: key,
                        name: objKeyFigure.Period,
                        type: (isEstimate ? 'line' : 'scatter'),
                        data: []
                    };
                }
                if (objKeyFigure.Currency == settings.estimateCurrency.toUpperCase() || settings.estimateCurrency == '') {
                    // only add values for the given currency if any is given
                    objSeriesList[key].data.push([moment(objKeyFigure.Date).valueOf(), objKeyFigure.Average]);
                }
            }
        });

        return $.map(objSeriesList, function (value, key) {
            return value;
        });

    }


    /**
    * Create a graph and set standard settings like colours, tooltips
    */
    function createChart(seriesList) {

        var objXAxis = {
            labels: {
                formatter: function () {
                    return getDateFormated(this.value);
                }
            },
            tickPixelInterval: 150
        },
           objYAxis = {
               labels: {
                   formatter: function () {
                       return getNumrericFormat(this.value.toString());
                   }
               },
               title: {
                   text: '',
                   margin: 0
               }
           },
        //Set the format on the tooltip
           objTooltip = {
               formatter: function () {
                   var head;

                   if (this.series.type === 'line') {
                       head = settings.tooltipHeaderEstimate;
                   } else {
                       head = settings.tooltipHeaderReal;
                   }
                   return '<span style="text-align:center;font-size:130%;"> ' + head + this.series.name + '</span><br/>' +
                       settings.dateString + getDateFormated(this.x) + '<br/>' +
                       settings.amountString + getNumrericFormat(this.y) + ' ' + getCurrencyWithPrefixes();
               }
           },
        objPlotOptions = {
            line: {
                lineWidth: 2,
                states: {
                    hover: {
                        lineWidth: 3
                    }
                },

                marker: {
                    enabled: false,
                    states: {
                        hover: {
                            enabled: true,
                            symbol: 'circle',
                            radius: 4,
                            lineWidth: 1
                        }
                    }
                }
            }
        },
        objLegend = {
            enabled: true,
            borderColor: '#DBDBDB',
            margin: 20,
            labelFormatter: function () {
                var head;
                if (this.type === 'line') {
                    head = settings.tooltipHeaderEstimate;
                } else {
                    head = settings.tooltipHeaderReal;
                }

                return head + this.name;
            }
        };

        chart = new Highcharts.Chart({
            chart: {
                renderTo: 'historicalDataContainer',
                defaultSeriesType: 'line'/*,
                events: {
                    load: requestData(type)
                }*/
            },

            series: seriesList,

            //Set the line colours
            //colors: [
            //    '#418a6a', // Actual 2010
            //    'black', // Estimate 2011
            //    '#64b8e0', // Estimate 2012
            //    'black', //
            //    '#bdbfc0', //
            //    '#49618c'  //
            //],

            xAxis: objXAxis,
            yAxis: objYAxis,

            //Set the format on the tooltip
            tooltip: objTooltip,

            //Defines and set the line settings
            plotOptions: objPlotOptions,

            legend: objLegend,

            credits: {
                enabled: false
            },

            title: {
                text: '',
                margin: 30
            }
        });

        return chart;
    }

    /**
    *Returns the date format ISO/other
    */

    function getDateFormated(dateNumber) {
        var formatString = 'YYYY-MM-DD';

        switch (settings.uiLanguage) {
            case "EN":
                formatString = 'MM/DD/YYYY';
                break;
            case "SV":
                formatString = 'YYYY-MM-DD';
                break;
            default:
                formatString = 'YYYY-MM-DD';
                break;
        }

        return moment(new Date(dateNumber)).format(formatString);
    }


    /**
    *Returns numeric format Swedish/ other
    */
    function getNumrericFormat(number) {
        var formatted;

        switch (settings.uiLanguage.toUpperCase()) {
            case "EN":
                formatted = $().number_format(number, { numberOfDecimals: 2, decimalSeparator: '.', thousandSeparator: ',' });
                break;
            case "SV":
                formatted = $().number_format(number, { numberOfDecimals: 2, decimalSeparator: ',', thousandSeparator: ' ' });
                break;
            default:
                formatted = $().number_format(number, { numberOfDecimals: 2, decimalSeparator: ',', thousandSeparator: ' ' });
                break;
        }

        return formatted;
    }

    /**
    *Returns the unit with added one letter prefix
    */
    function getCurrencyWithPrefixes() {
        var formatted;

        var unit = settings.unit;

        switch (settings.quantum) {
            case "Quadrillion":
                formatted = unit + "Y";
                break;
            case "Trilliard":
                formatted = unit + "Z";
                break;
            case "Trillion":
                formatted = unit + "E";
                break;
            case "Billiard":
                formatted = unit + "P";
                break;
            case "Billion":
                formatted = unit + "T";
                break;
            case "Milliard":
                formatted = unit + "G";
                break;
            case "Million":
                formatted = "M" + unit;
                break;
            case "Thousand":
                formatted = unit + "k";
                break;
            case "Hundred":
                formatted = unit + "h";
                break;
            case "Ten":
                formatted = unit + "d";
                break;
            case "MT":
                formatted = "MT";
                break;
            default:
                formatted = unit;
                break;
        }

        return formatted;
    }



    return {
        render: render
    };
}(jQuery);
